import { cn } from "@/lib/utils";

export const GlowField = ({ className }) => (
  <div aria-hidden="true" className={cn("pointer-events-none absolute inset-0 -z-10 overflow-hidden", className)}>
    <div className="glow-orb glow-orb--blue" />
    <div className="glow-orb glow-orb--teal" />
    <div className="glow-orb glow-orb--accent" />
  </div>
);
